import { AccountConfirmation } from '@/features/growgen/AccountConfirmation';
// © 2025 Camp Promethean, LLC. All Rights Reserved.

import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { EmberLoadingScreen } from "@/components/loading";
import { useAuth } from "@/contexts/AuthContext";

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const location = useLocation();
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return <EmberLoadingScreen variant="app" />;
  }

  if (!isAuthenticated) {
    sessionStorage.setItem("postLoginReturnTo", location.pathname + location.search);
    return <Navigate to="/login" replace />;
  }

  return <AccountConfirmation>{children}</AccountConfirmation>;
};

export default ProtectedRoute;
